import NextImage, { ImageProps as NextImageProps } from 'next/image'
import React, { CSSProperties, useMemo } from 'react'

import Base64 from 'app/utils/helpers/base64.helpers'
import imageLoader from 'app/utils/helpers/imageLoader'

export interface ImageProps
  extends Omit<NextImageProps, 'objectFit' | 'objectPosition'> {
  objectFit?: CSSProperties['objectFit']
  objectPosition?: CSSProperties['objectPosition']
}

const Image = ({
  src,
  width = 64,
  height = 64,
  sizes,
  children,
  fill,
  objectFit = 'cover',
  objectPosition = 'center',
  alt,
  style,
  priority,
  loading,
  quality,
  blurDataURL,
  placeholder,
  onLoad
}: ImageProps) => {
  const needImageProxy =
    typeof src === 'string' && process.env.NODE_ENV !== 'development'
  const baseImage = useMemo(() => Base64.btoa(String(src)), [src])
  const image = needImageProxy ? baseImage : src

  return (
    <>
      {src ? (
        <NextImage
          {...(needImageProxy && { loader: imageLoader })}
          src={image}
          fill={fill}
          {...(!fill && { width, height })}
          sizes={sizes}
          alt={alt}
          priority={priority}
          loading={loading}
          quality={quality}
          onLoad={onLoad}
          placeholder={placeholder}
          blurDataURL={
            blurDataURL ??
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8+PHLfwAJiAPXXPiwhQAAAABJRU5ErkJggg=='
          }
          style={{ ...style, objectFit, objectPosition }}
        />
      ) : (
        children
      )}
    </>
  )
}

export default Image
